import React, { useEffect } from "react";
import { useTypedSelector } from "../store";
import { useDispatch } from "react-redux";
import { getErrUploadRequest } from "../slices/error";

const ErrorUpload = () => {
  const dispatch = useDispatch();
  const { errors } = useTypedSelector((state) => {
    return {
      errors: state.Error.uploadSheduleErrors,
    };
  });

  useEffect(() => {
    dispatch(getErrUploadRequest() as any);
  }, []);

  console.log("ERRRR", errors);

  return (
    <div>
      <h1>Error List</h1>
      {errors &&
        errors.map((item, index) => (
          <div
            key={item._id}
            style={{
              marginBottom: 40,
              borderWidth: 1,
              borderColor: "black",
              borderStyle: "solid",
              borderRadius: 10,
              padding: 10,
            }}
          >
            <p>
              <strong>ID:</strong> {item._id}
            </p>
            {item.shift && item.shift.errorMessageSchedule ? (
              <>
                <p>
                  <strong>
                    Shift Errors: {item.shift.errorMessageSchedule.length}
                  </strong>
                </p>
                <ul>
                  {item.shift.errorMessageSchedule.map(
                    (error: any, index: any) => (
                      <li key={index}>
                        <text style={{ color: "red" }}>{error}</text>
                      </li>
                    )
                  )}
                </ul>
              </>
            ) : (
              <p>No Shift Errors</p>
            )}

            {item.employee ? (
              item.employee.errorMessageEmployee &&
              item.employee.errorMessageEmployee.length > 0 ? (
                <>
                  <p>
                    <strong>
                      Employee Errors:{" "}
                      {item.employee.errorMessageEmployee.length}
                    </strong>
                  </p>
                  <ul>
                    {item.employee.errorMessageEmployee.map(
                      (error: any, index: number) => (
                        <li key={index}>
                          <text style={{ color: "red" }}>{error}</text>
                        </li>
                      )
                    )}
                  </ul>
                </>
              ) : (
                <p>No Employee Errors</p>
              )
            ) : (
              <p>Employee Data Not Available</p>
            )}

            {item.schedule && item.schedule.reasonError ? (
              <>
                <p>
                  <strong>
                    Schedule Errors: {item.schedule.reasonError.length}
                  </strong>
                  <ul>
                    {item.schedule.reasonError.map(
                      (reason: any, index: any) => (
                        <li key={index}>
                          <text style={{ color: "red" }}>{reason}</text>
                        </li>
                      )
                    )}
                  </ul>
                </p>
              </>
            ) : (
              <p>No Schedule Errors</p>
            )}

            {item.ctAllowance && item.ctAllowance.errorCTallowanceCount ? (
              <>
                <p>
                  <strong>
                    Leave Errors: {item.ctAllowance.errorCTallowanceCount}
                  </strong>
                  <ul>
                    {item.ctAllowance.errorMessage.map(
                      (reason: any, index: any) => (
                        <li key={index}>
                          <text style={{ color: "red" }}>{reason}</text>
                        </li>
                      )
                    )}
                  </ul>
                </p>
              </>
            ) : (
              <p>No Leave Errors</p>
            )}

            {/* {item.schedule.reasonError.length > 0 ? (
            <ul>
              {item.schedule.reasonError.map((reason: any, index: any) => (
                <li key={index}>
                  <text style={{ color: "red" }}>{reason}</text>
                </li>
              ))}
            </ul>
          ) : (
            <p>No Upload Errors</p>
          )} */}
            <p>
              <strong>Created At:</strong>{" "}
              {new Date(item.createdAt).toLocaleString()}
            </p>
          </div>
        ))}
    </div>
  );
};

export default ErrorUpload;
